import { Image } from 'expo-image';
import { router } from 'expo-router';
import { StyleSheet, View } from 'react-native';
import { Divider } from 'react-native-paper';

import { NonProfitOrgProfileResponse } from '@/api/models/nonProfitOrgModels';
import { programDefaultIcon } from '@/assets/images/icons';
import EditButton from '@/components/buttons/EditButton';
import InfoButton from '@/components/buttons/InfoButton';
import Text from '@/components/Text';
import { useColor } from '@/hooks/useColor';
import { firebaseImage } from '@/utils/firebaseImage';
import { i18n } from '@/utils/i18n';

const AmenitiesItem = ({
  canEdit,
  data,
  npoId
}: {
  canEdit: boolean;
  data: NonProfitOrgProfileResponse['amenities'];
  npoId: NonProfitOrgProfileResponse['id'];
}) => {
  const colors = useColor();
  return (
    <View>
      <View style={styles.titleContainer}>
        <View style={styles.titleContent}>
          <Text style={[styles.titleText, { color: colors.titleText }]} fontWeight="700">
            {i18n.t('npo_details.insights.amenities')}
          </Text>
          {/* // TODO: update tooltip title  */}
          <InfoButton title={i18n.t('npo_details.insights.amenities')} />
        </View>
        {canEdit && (
          <EditButton
            onPress={() => {
              router.navigate({
                pathname: '/create/amenities',
                params: {
                  npoId: npoId,
                  initialList: JSON.stringify(data)
                }
              });
            }}
          />
        )}
      </View>
      <View style={styles.content}>
        {data && data.length > 0 ? (
          data.map((amenity, index) => (
            <View style={styles.row} key={index}>
              <Image
                source={amenity.thumbnail ? firebaseImage(amenity.thumbnail) : programDefaultIcon}
                style={styles.image}
                contentFit="fill"
              />
              <Text style={[styles.valueText, { color: colors.titleText }]}>{amenity.title}</Text>
            </View>
          ))
        ) : (
          <Text> {i18n.t('mix.n_a')}</Text>
        )}
      </View>
      <Divider />
    </View>
  );
};

export default AmenitiesItem;

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  titleContent: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center'
  },

  titleText: {
    fontSize: 22,
    marginRight: 10
  },

  content: {
    marginTop: 10,
    marginBottom: 20
  },

  row: {
    flexDirection: 'row',
    marginTop: 15
  },

  valueText: {
    minWidth: 120,
    marginRight: 10,
    marginBottom: 5
  },

  image: {
    marginRight: 16,
    width: 28,
    height: 28
  },

  addAmenitiesBtn: {
    marginTop: 20
  }
});
